
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CountdownTimer from '../../components/feature/CountdownTimer';
import Button from '../../components/base/Button';
import Card from '../../components/base/Card';
import { Link } from 'react-router-dom';

export default function Competition() {
  const importantDates = [
    {
      date: '07 Haziran 2026',
      title: 'Kayıt Son Tarihi',
      description: 'Yarışmaya katılım için son kayıt tarihi',
      icon: 'ri-calendar-line',
      color: 'from-red-400 to-red-500'
    },
    {
      date: '20 Haziran 2026',
      title: 'Yarışma Tarihi',
      description: 'Online sınav tarihi',
      icon: 'ri-file-text-line',
      color: 'from-blue-400 to-blue-500'
    },
    {
      date: '31 Haziran 2026',
      title: 'Sonuçların Açıklanması',
      description: 'Kazananların duyurulması',
      icon: 'ri-trophy-line',
      color: 'from-yellow-400 to-yellow-500'
    }
  ];

  const rules = [
    'Yarışmaya katılım ücretsizdir.',
    'Katılımcılar belirlenen kitabı tamamen okumalıdır.',
    'Sınav online olarak gerçekleştirilecektir.',
    'Sınav süresi 90 dakikadır.',
    'Toplam 100 soru sorulacaktır.',
    'En yüksek puanı alan ilk 1.000 kişi ödül kazanacaktır.',
    'Kopya çekmek veya hile yapmak kesinlikle yasaktır.',
    'Sonuçlar objektif değerlendirme ile belirlenecektir.'
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-slate-800 to-slate-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Kitap & <span className="text-yellow-400">Yarışma Detayları</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto">
              Girişimcilik kitabını okuyun, bilginizi test edin ve muhteşem ödülleri kazanın!
            </p>
          </div>
          
          <div className="max-w-2xl mx-auto">
            <CountdownTimer />
          </div>
        </div>
      </section>

      {/* Book Details */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-6">
                Okunacak Kitap
              </h2>
              <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 rounded-lg p-1 mb-6 inline-block">
                <div className="bg-white rounded-md px-4 py-2">
                  <h3 className="text-2xl font-bold">
                    "Motivasyon Gücüyle Girişimcilik Rehberi"
                  </h3>
                </div>
              </div>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center space-x-3">
                  <i className="ri-user-line text-yellow-600 text-xl"></i>
                  <span className="text-gray-700"><strong>Yazar:</strong> Zafer Yılmaz Özer</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-book-line text-yellow-600 text-xl"></i>
                  <span className="text-gray-700"><strong>Sayfa Sayısı:</strong> 280 sayfa</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-calendar-line text-yellow-600 text-xl"></i>
                  <span className="text-gray-700"><strong>Yayın Yılı:</strong> 2024</span>
                </div>
              </div>

              <p className="text-lg text-gray-600 mb-8">
                Bu kitap, girişimcilik yolculuğunda motivasyonun gücünü keşfetmenizi sağlayan kapsamlı bir rehberdir. 
                Vizyon oluşturma, hedef belirleme, strateji geliştirme ve başarıya ulaşma konularında 
                pratik örnekler ve gerçek hayat hikayeleri içermektedir.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                <Card padding="sm">
                  <h4 className="font-semibold text-slate-800 mb-2">Bölüm 1-3</h4>
                  <p className="text-sm text-gray-600">Motivasyon ve Vizyon</p>
                </Card>
                <Card padding="sm">
                  <h4 className="font-semibold text-slate-800 mb-2">Bölüm 4-6</h4>
                  <p className="text-sm text-gray-600">Strateji ve Planlama</p>
                </Card>
                <Card padding="sm">
                  <h4 className="font-semibold text-slate-800 mb-2">Bölüm 7-9</h4>
                  <p className="text-sm text-gray-600">Uygulama ve Eylem</p>
                </Card>
                <Card padding="sm">
                  <h4 className="font-semibold text-slate-800 mb-2">Bölüm 10-12</h4>
                  <p className="text-sm text-gray-600">Başarı ve Sürdürülebilirlik</p>
                </Card>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <Button size="lg">
                  <i className="ri-download-line mr-2"></i>
                  PDF İndir
                </Button>
                <Button variant="outline" size="lg">
                  <i className="ri-shopping-cart-line mr-2"></i>
                  Kitabı Satın Al
                </Button>
              </div>
            </div>
            
            <div className="order-1 lg:order-2">
              <img 
                src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/4fb6cdc11f79cfa6cbb5a2aebb33267c.png"
                alt="Motivasyon Gücüyle Girişimcilik Rehberi Kitabı"
                className="w-full max-w-md mx-auto rounded-lg shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Important Dates */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
              Önemli Tarihler
            </h2>
            <p className="text-xl text-gray-600">
              Yarışma sürecindeki kritik tarihleri kaçırmayın
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {importantDates.map((item, index) => (
              <Card key={index} className="text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                <div className={`w-16 h-16 bg-gradient-to-r ${item.color} rounded-full flex items-center justify-center mx-auto mb-6`}>
                  <i className={`${item.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-slate-800 mb-2">
                  {item.title}
                </h3>
                <div className="text-2xl font-bold text-yellow-600 mb-4">
                  {item.date}
                </div>
                <p className="text-gray-600">
                  {item.description}
                </p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Competition Rules */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-8">
                Yarışma Kuralları
              </h2>
              <div className="space-y-4">
                {rules.map((rule, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-yellow-400 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <span className="text-xs font-bold text-gray-900">{index + 1}</span>
                    </div>
                    <p className="text-gray-700">{rule}</p>
                  </div>
                ))}
              </div>
            </div>
            
            <div>
              <Card className="bg-gradient-to-br from-slate-800 to-slate-900 text-white">
                <h3 className="text-2xl font-bold mb-6">Sınav Formatı</h3>
                <div className="space-y-4">
                  <div className="flex justify-between items-center border-b border-gray-600 pb-2">
                    <span>Soru Sayısı:</span>
                    <span className="font-bold text-yellow-400">100</span>
                  </div>
                  <div className="flex justify-between items-center border-b border-gray-600 pb-2">
                    <span>Süre:</span>
                    <span className="font-bold text-yellow-400">90 Dakika</span>
                  </div>
                  <div className="flex justify-between items-center border-b border-gray-600 pb-2">
                    <span>Format:</span>
                    <span className="font-bold text-yellow-400">Çoktan Seçmeli</span>
                  </div>
                  <div className="flex justify-between items-center border-b border-gray-600 pb-2">
                    <span>Platform:</span>
                    <span className="font-bold text-yellow-400">Online</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span>Kazanan Sayısı:</span>
                    <span className="font-bold text-yellow-400">1.000 Kişi</span>
                  </div>
                </div>
              </Card>

              <Card className="mt-8">
                <h3 className="text-xl font-bold text-slate-800 mb-4">
                  Değerlendirme Kriterleri
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-center space-x-2">
                    <i className="ri-check-line text-green-5

0"></i>
                    <span>Doğru cevap sayısı</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <i className="ri-check-line text-green-500"></i>
                    <span>Sınav tamamlanma süresi</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <i className="ri-check-line text-green-500"></i>
                    <span>Kayıt tarihi (eşitlik durumunda)</span>
                  </li>
                </ul>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-yellow-400 to-yellow-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Hemen Başlayın!
          </h2>
          <p className="text-xl text-gray-800 mb-8">
            Kitabı okumaya başlayın ve yarışmaya hazırlanın
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/register">
              <Button variant="secondary" size="lg" className="w-full sm:w-auto">
                <i className="ri-user-add-line mr-2"></i>
                Kayıt Ol
              </Button>
            </Link>
            <Link to="/prizes">
              <Button variant="outline" size="lg" className="w-full sm:w-auto border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white">
                <i className="ri-gift-line mr-2"></i>
                Ödülleri Gör
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
